import { RoundProfilePicture } from "components/atoms";
import React, { FC, useCallback, useEffect, useLayoutEffect, useState } from "react"
import { TContactItems } from "../Contact";
import ClipLoader from "react-spinners/ClipLoader";
import styles from "../Contact.module.css";
import { getAssetPathAndSize, useSectionAccordionWrapper } from "utils";
import he from "he";
import { AnimatePresence, motion } from "framer-motion";
import { Linkedin, Mail, Twitter } from "react-social-sharing";
import $ from "jquery";
import classNames from "classnames";

type TContactModalCardProps = {
    activeCard: TContactItems;
}

export const ContactModalCard: FC<TContactModalCardProps> = ({
    activeCard
}) => {
    const [displayBio, setDisplayBio] = useState<boolean>(false);
    const emailSubject = $('title').text();

    useSectionAccordionWrapper();

    useEffect(() => {
        setTimeout(() => {
            setDisplayBio(true);
        }, 800)
    }, []);

    useLayoutEffect(() => {
        Array.from(document.querySelectorAll('.accordian-wrapper a')).forEach(element => {
            element.classList.add('button-2022')
        });

    }, [])

    // Open links in new browser window
    const openTarget = (e: any, l: string) => {
        e.preventDefault()
        window.open(l, '_blank', 'location=yes,height=650,width=500,scrollbars=yes,status=yes')
    };

    const openEmail = (e: any, address: string) => {
        e.preventDefault()
        const mail = `mailto:${address}?subject=Sent from Aurecon: ${emailSubject}&body=I am emailing you from: ${window.location.href}`;
        window.open(mail);
    };

    const SocialMedia = () => {
        const list = [
            activeCard.LinkedInProfile?.Url && { type: "linkedin", href: activeCard.LinkedInProfile.Url, icon: <Linkedin /> },
            activeCard.TwitterProfile?.Url && { type: "twitter", href: activeCard.TwitterProfile.Url, icon: <Twitter /> },
            activeCard.ContactEmail && { type: "mail", href: activeCard.ContactEmail, icon: <Mail /> }
        ]
        return (
            <div className={styles.socialContainer}>
                {list.map(({ href, icon, type }, i) => {
                    return (
                        <div className={styles.socialItemWrapper} key={type + '-icon-' + i}>
                            {type === "mail" ?
                                <div className={classNames(styles[type], "icon")}>
                                    <div
                                        className={styles.social}
                                        onClick={(e) => openEmail(e, href)}
                                    >
                                        {icon}
                                    </div>
                                </div>
                                :
                                <>
                                    {["test", "twitter", "linkedin", "mail"].includes(type) &&
                                        <div className={classNames(styles[type], "icon")}>
                                            <div
                                                className={styles.social}
                                                onClick={(e) => openTarget(e, href)}
                                            >
                                                {icon}
                                            </div>
                                        </div>
                                    }
                                </>

                            }
                        </div>
                    )
                })}
            </div>
        )
    };


    return (
        <div className={styles.contactModalCard}>
            <div>
                <RoundProfilePicture
                    image={{ Src: getAssetPathAndSize(activeCard.Photo?.Src, 30), Alt: activeCard.Photo?.Alt }}
                    width="209px" />
                <div className={styles.socialMedia}>
                    <SocialMedia />
                </div>
            </div>
            <div className="text">
                <div> <span>{activeCard.Firstname + ' ' + activeCard.Surname}</span></div>
                <div> <p style={{ textTransform: 'uppercase' }}>{he.decode(activeCard.ContactJobPosition)}</p></div>
                {Boolean(activeCard.FullBio) &&
                    <motion.div className="accordian-wrapper"
                    initial={{ overflowX: 'hidden', overflow: 'hidden' }}
                    animate={{ overflow: displayBio ? 'auto' : 'hidden', }}
                    >
                        <motion.div
                            dangerouslySetInnerHTML={{ __html: activeCard.FullBio }}
                            initial={{ display: 'none' }}
                            animate={{
                                opacity: displayBio ? 1 : 0,
                                display: displayBio ? 'block' : 'none',
                                paddingBottom: displayBio ? '50px' : '0px'
                            }}
                            className="pb-none">
                        </motion.div>
                        <ClipLoader color={"#84bd00"} css={'margin: 0px auto'} loading={!displayBio} size={40} />
                    </motion.div>
                }

            </div>
        </div>
    )
}